import React from 'react'
import Modal from 'react-modal'
import styles from './item.module.css'
import VideoModal from './video-modal.jsx'

class itemVideo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            showModal: false
        }
        this.handleOpenModal = this.handleOpenModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
    }
    handleOpenModal() {
        this.setState({ showModal: true })
    }
    handleCloseModal() {
        this.setState({ showModal: false })
    }
    render() {
        if (this.props.data) {
            return (
                <div className={styles.contentRoot}>
                    <div className={styles.contentVideo}>
                        <div
                            onClick={this.handleOpenModal}
                            className={styles.contentVideoPlay}
                        />
                    </div>
                    <Modal
                        className={styles.modalContent}
                        overlayClassName={styles.modalOverlay}
                        isOpen={this.state.showModal}
                        contentLabel="onRequestClose Example"
                        onRequestClose={this.handleCloseModal}
                    >
                        <VideoModal
                            videoUrl={this.props.data.content}
                            onClose={() => {
                                this.handleCloseModal()
                            }}
                        />
                    </Modal>
                    {/* <video className={ styles.contentVideo} src={this.props.data.content}></video> */}
                    {/* VIDEO - {this.props.data.content} */}
                </div>
            )
        } else {
            return <div />
        }
    }
}
export default itemVideo
